<template>
    <div :class="[
        !isHorizontal ? 'w-full border-t my-2' : 'h-6 border-l mx-2',
        'border-gray-600',
        className
    ]" role="separator" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'NavigationSeparator',
    props: {
        isHorizontal: {
            type: Boolean,
            default: true
        },
        class: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const className = props.class;
        return {
            className
        };
    }
});
</script>